import React, { ReactNode, createContext, useContext, useEffect, useMemo, useState } from 'react';

import { WikiNode } from './types';

type CurrentNodeContextValue = {
  node: WikiNode | null;
  showNode: (node: WikiNode | null) => void;
};

const CurrentNodeContext = createContext<CurrentNodeContextValue>({ node: null, showNode: () => undefined });

export const useCurrentNode = () => useContext(CurrentNodeContext).node;

export const useShowCurrentNode = (node: WikiNode | null) => {
  const { showNode } = useContext(CurrentNodeContext);

  useEffect(function showTheOpenedNodeInNavigation() {
    showNode(node);
    return () => showNode(null);
  }, [node, showNode]);
};

const CurrentNodeProvider = ({ children }: { children: ReactNode }) => {
  const [node, setNode] = useState<WikiNode | null>(null);
  const value = useMemo(() => ({ node, showNode: setNode }), [node]);

  return <CurrentNodeContext.Provider value={value}>{children}</CurrentNodeContext.Provider>;
};

export default CurrentNodeProvider;
